import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

import { PopupErrorObject } from '../models';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

/**
 * This is a commonly shared error handler.
 * Add it to the chain of handlers in app.module.ts like:
 * ErrorHandlerModule.forRoot({ useErrorHandlers: [STErrorHandlerService, MissingHoldingErrorHandlerService]})
 * If you want to customize, please add to application level handler
 * e.g. st-error-handler.service
 */
@Injectable()
export class NotFoundErrorHandlerService extends AbstractErrorHandlerService {
	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		let errorCodes = [];
		if (get(error, 'responseJson.errorCodes') && !Array.isArray(error.responseJson.errorCodes)) {
			errorCodes = Object.values(error.responseJson.errorCodes).map(error => error['errorCode']);
		} else {
			errorCodes = get(error, 'responseJson.errorCodes', []);
		}
		const containsPopupError = error instanceof PopupErrorObject && !error.responseJson.allDataReturned && error.responseJson.errorCodes;
		if (containsPopupError && errorCodes.includes(ERROR_CODES.NOT_FOUND_OR_UNAUTHORIZED) || errorCodes.includes(ERROR_CODES.PORTFOLIO_NOT_FOUND)) {
			this.errorMessage = this.contentService.get('NOT_FOUND_OR_UNAUTHORIZED', ErrorDCR.NOT_FOUND_OR_UNAUTHORIZED);
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = 'notfoundorunauthorized';
			this.actionMessage = this.contentService.get('ERROR_NEW_ANALYSIS_MESSAGE', ErrorDCR.ERROR_NEW_ANALYSIS_MESSAGE);
			this.actionLabel = this.contentService.get('ERROR_NEW_ANALYSIS_LABEL', ErrorDCR.ERROR_NEW_ANALYSIS_LABEL);
			this.actionType = 'view_new_analysis';


			console.error('There was an error: NOT_FOUND_OR_UNAUTHORIZED', error);
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
			this.errorPopupService.openResponseMessageDialog(this.buildErrorMessage(), true);
		} else if (error instanceof PopupErrorObject && error.responseJson.error && error.config === 'engagementPortfolios' && error.responseJson.error.includes('not found')) {
			this.errorMessage = this.contentService.get('ENGAGEMENT_NOT_FOUND_OR_UNAUTHORIZED', ErrorDCR.ENGAGEMENT_NOT_FOUND_OR_UNAUTHORIZED);
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = 'engagementnotfoundorunauthorized';
			if (error.responseJson?.action === 'REDIRECT_TO_NEW_ANALYSIS') {
				this.actionMessage = this.contentService.get('ERROR_NEW_ANALYSIS_MESSAGE', ErrorDCR.ERROR_NEW_ANALYSIS_MESSAGE);
				this.actionLabel = this.contentService.get('ERROR_NEW_ANALYSIS_LABEL', ErrorDCR.ERROR_NEW_ANALYSIS_LABEL);
				this.actionType = 'view_new_analysis';
			} else {
				this.actionMessage = this.contentService.get('ERROR_VIEW_SAVED_PORTFOLIOS_MESSAGE', ErrorDCR.ERROR_VIEW_SAVED_PORTFOLIOS_MESSAGE);
				this.actionLabel = this.contentService.get('ERROR_VIEW_SAVED_PORTFOLIOS_LABEL', ErrorDCR.ERROR_VIEW_SAVED_PORTFOLIOS_LABEL);
				this.actionType = 'view_library';
			}

			console.error('There was an error: ENGAGEMENT_NOT_FOUND_OR_UNAUTHORIZED', error);
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
			this.errorPopupService.openResponseMessageDialog(this.buildErrorMessage(), true);

		} else {
			this.nextHandler.handleError(error);
		}
	}
}
